export default "/assets/website/components/images/auth.660d9ae0.svg";